module.exports = __webpack_public_path__ + "media/sensor_alert.dc828a04.wav";